import type { CSSProperties } from "react";

// WoW classes as stored in the API (db strings), plus labels and class colours (chosen for the dark-mode-only bg).

export const WOW_CLASSES = [
  "death_knight",
  "demon_hunter",
  "druid",
  "evoker",
  "hunter",
  "mage",
  "monk",
  "paladin",
  "priest",
  "rogue",
  "shaman",
  "warlock",
  "warrior",
] as const;
export type WowClass = (typeof WOW_CLASSES)[number];

export const WOW_CLASS_LABELS: Record<WowClass, string> = {
  death_knight: "Death Knight",
  demon_hunter: "Demon Hunter",
  druid: "Druid",
  evoker: "Evoker",
  hunter: "Hunter",
  mage: "Mage",
  monk: "Monk",
  paladin: "Paladin",
  priest: "Priest",
  rogue: "Rogue",
  shaman: "Shaman",
  warlock: "Warlock",
  warrior: "Warrior",
};

const WOW_CLASS_COLORS: Record<WowClass, string> = {
  death_knight: "#C41E3A",
  demon_hunter: "#A330C9",
  druid: "#FF7C0A",
  evoker: "#33937F",
  hunter: "#AAD372",
  mage: "#3FC7EB",
  monk: "#00FF98",
  paladin: "#F48CBA",
  priest: "#FFFFFF",
  rogue: "#FFF468",
  shaman: "#0070DD",
  warlock: "#8788EE",
  warrior: "#C69B6D",
};

// Inline `style` is the documented exception to semantic tokens (CLAUDE.md): exact theme-independent hex.
// Returns undefined for null/unknown classes — callers render grey.
export function classColorStyle(
  wowClass: string | null | undefined,
): CSSProperties | undefined {
  if (!wowClass) return undefined;
  const color = WOW_CLASS_COLORS[wowClass as WowClass];
  return color ? { color } : undefined;
}
